'use client';

// Package Imports
import React, { useState } from 'react';
//import Link from 'next/link';
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';

// Component Imports
import Toast from '@/components/toast';

// Type Imports
import { FulfillmentStore as FulfillmentStoreType } from '@/lib/types/fulfillmentStore';
import { Store } from '@/lib/types/store';

// Function Imports
import { ProductStockState } from '@/lib/functions/checkProductStock';
//import { getStore } from '@/lib/functions/getStore';

// Style Imports
import styles from './productStock.module.scss';

// Define Interfaces
interface ProductStockProps {
  stockState?: ProductStockState;
  productSku: string | number | undefined;
  guestUserStore?: (store: Store | FulfillmentStoreType) => void;
}

export const ProductStock: React.FC<ProductStockProps> = ({
  stockState,
}) => {

  //const [toastMessage, setToastMessage] = useState<string | null>(null);
  //const [toastType, setToastType] = useState<'success' | 'error'>('success');
  const [toastVisible, setToastVisible] = useState(false);

  const {
    inStock   = false,
    lowStock  = false,
    message   = 'Out of stock',
  } = stockState ?? {};

  return (
    <div className={styles.stock}>
      {toastVisible && (
        <div className={styles.toasts}>
          <Toast
            id={uuidv4()}
            type={'error'}
            label={false}
            dismissible
            onDismiss={() => setToastVisible(false)}
            message={'Unknown error'}
          />
        </div>
      )}

      <div
        className={classNames(styles.status, {
          [styles.lowStock]: inStock && lowStock,
          [styles.outOfStock]: !inStock,
        })}
      >
        <div className={styles.stockIndicator} />
        <div>
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
};
